// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__S9EbY","collapsing":"Sidebar_collapsing__cQPOk","open":"Sidebar_open__X2Wv0"};